/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZohoServiceDeskUser {
    getFixupPrototypeFunction() { return ZohoServiceDeskUser.fixupPrototype; }

    static newInstance(model: Partial<ZohoServiceDeskUser>): ZohoServiceDeskUser {
        let obj = Object.assign(new ZohoServiceDeskUser(), model);
        ZohoServiceDeskUser.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZohoServiceDeskUser>): ZohoServiceDeskUser {
        if (!model) return null;
        return ZohoServiceDeskUser.newInstance(<ZohoServiceDeskUser> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZohoServiceDeskUser) {
        if (!obj) return;

        models.ZohoServiceDeskUser.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZohoServiceDeskUser): boolean {
        Object.setPrototypeOf(obj, ZohoServiceDeskUser.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the user
     */
    user_id: string;

    /**
     * Name for user
     */
    user_name: string;

}
